import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ColorPallet } from "../../utils/colorPallet";
interface IProps {
  headerData?: any;
  rowData?: any;
  totalItems?: number;
  totalQuantity?: number;
  totalAmount?: number;
  totalDiscount?: number;
  totalDiscountedAmount?: number;
  discountPercentage?: any;
  discount?: any;
  hasDiscountPercentagePrevious?: any;
  isPrint?: any;
  totalDue?: any;
  totalPaid?: any;
}

const CustomerDetailsInvoiceTable = ({
  rowData,
  headerData,
  totalItems,
  totalQuantity,
  totalAmount,
  totalDiscount,
  totalDiscountedAmount,
  discountPercentage,
  discount,
  hasDiscountPercentagePrevious,
  isPrint,
  totalDue,
  totalPaid,
}: IProps) => {
  const filteredHeaderData = hasDiscountPercentagePrevious
    ? [...headerData, "Disc", "Payable Amt"]
    : headerData;

  const [totalDiscountedAmtPrnt, setTotalDiscountedAmtPrnt] = useState(0);
  useEffect(() => {
    // Calculate discounted amounts for each item and sum them
    const calculatedDiscounts = rowData?.map((item: any) => {
      return item?.Amt - item?.Discount;
    });

    // Sum the calculated discounted amounts
    const total = calculatedDiscounts?.reduce(
      (acc: any, curr: any) => acc + curr,
      0
    );
    setTotalDiscountedAmtPrnt(total);
  }, [rowData]);

  return (
    <>
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="simple table">
          <TableHead sx={{ backgroundColor: ColorPallet.tableHeaderColor }}>
            <TableRow
              sx={{
                borderBottom: `1px solid black`,
                //borderTop: `1px solid black`,
              }}
            >
              {filteredHeaderData?.map((headerItem: any, index: any) => (
                <TableCell
                  key={index}
                  sx={{
                    borderBottom: `1px solid black`,
                    padding: "6px",
                    height: "24px",
                    fontSize: "24px",
                  }}
                >
                  {headerItem}
                </TableCell>
              ))}
              {!hasDiscountPercentagePrevious ? (
                <>
                  {/* Render empty cells to maintain alignment */}
                  <TableCell
                    sx={{
                      borderBottom: `1px solid black`,
                      fontSize: "24px",
                      padding: "6px",
                      height: "22px",
                      textAlign: "center",
                    }}
                  />
                  <TableCell
                    sx={{
                      borderBottom: `1px solid black`,
                      fontSize: "24px",
                      padding: "6px",
                      height: "22px",
                    }}
                  />
                </>
              ) : null}
            </TableRow>
          </TableHead>

          <TableBody>
            {rowData?.map((row: any, rowIndex: any) => {
              return (
                <TableRow key={rowIndex}>
                  {headerData?.map((headerItem: any, colIndex: any) => (
                    <TableCell
                      key={colIndex}
                      sx={{
                        borderBottom: `1px solid black`,
                        fontSize: "24px",
                        padding: "6px",
                        height: "22px",
                      }}
                    >
                      {headerItem === "QTY" ||
                      headerItem === "Amt" ||
                      headerItem === "Price"
                        ? row[headerItem]
                          ? row[headerItem].toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : ""
                        : row[headerItem]}{" "}
                    </TableCell>
                  ))}
                  {/* Conditionally render "Discount" and "Payable Amt" values */}
                  {hasDiscountPercentagePrevious ? (
                    <>
                      <TableCell
                        sx={{
                          borderBottom: `1px solid black`,
                          fontSize: "24px",
                          padding: "6px",
                          height: "22px",
                          textAlign: "center",
                        }}
                      >
                        {row.Discount
                          ? Math.round(row.Discount).toLocaleString("en-IN")
                          : "0"}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: `1px solid black`,
                          fontSize: "24px",
                          padding: "6px",
                          height: "22px",
                          textAlign: "center",
                        }}
                      >
                        {isPrint
                          ? Math.round(
                              row?.Amt - (row.Discount || 0)
                            ).toLocaleString("en-IN")
                          : Math.round(row["Payable Amt"])?.toLocaleString(
                              "en-IN"
                            )}
                      </TableCell>
                    </>
                  ) : (
                    <>
                      {/* Render empty cells to maintain alignment */}
                      <TableCell
                        sx={{
                          borderBottom: `1px solid black`,
                          fontSize: "24px",
                          padding: "6px",
                          height: "22px",
                          textAlign: "center",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderBottom: `1px solid black`,
                          fontSize: "24px",
                          padding: "6px",
                          height: "22px",
                          textAlign: "center",
                        }}
                      />
                    </>
                  )}
                </TableRow>
              );
            })}

            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 500,
                  padding: "6px",
                  fontSize: "22px",
                }}
              >
                Total
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 400,
                  padding: "6px",
                  fontSize: "22px",
                }}
              >
                {totalAmount}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 400,
                  padding: "6px",
                  fontSize: "22px",
                }}
              >
                {totalDiscount}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 400,
                  padding: "6px",
                  fontSize: "22px",
                }}
              >
                {totalPaid}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 400,
                  padding: "6px",
                  fontSize: "22px",
                }}
              >
                {totalDue}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default CustomerDetailsInvoiceTable;
